import ApiModelWithAuth from "../../../../models/ApiModelWithAuth";
import Formatter from "../../../../models/Formatter";

export class OrderToEmailFormatter extends Formatter {}
export default class ApiOrderToEmail extends ApiModelWithAuth {
  pathDef = 'authorized/admin/order/certificates/send/email';

  formatterItem = OrderToEmailFormatter.Item;
}